export var CarrierNotAvailable = function CarrierNotAvailable(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getDescription();
    }
  };
};
var CarrierNotAvailableBuilder = function CarrierNotAvailableBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "OmGYKr",
        defaultMessage: [{
          "type": 0,
          "value": "Transporteur indisponible"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "0tajdp",
        defaultMessage: [{
          "type": 0,
          "value": "Le transporteur que vous avez sélectionné n'expédie pas de colis à l'adresse de destination que vous avez renseignée. Vous pouvez sélectionner un autre transporteur ou choisir d'expédier la commande par vous-même."
        }]
      })];
    }
  };
};